import { ApiUtil } from 'lecom-api';

export default class FormStoreValuesSynchronizer {

	static sync(gridFormName, values) {
		const fieldAPI = ApiUtil.getFieldAPI(gridFormName);
		const formAPI = ApiUtil.getFormAPI();

		Object.keys(values)
			.filter(dataRowKey => !dataRowKey.includes('Display') && dataRowKey !== 'id')
			.forEach(fieldId => {
				let value = values[fieldId];

				if (value === null || value === undefined)
					value = "";

				if (typeof value === 'string')
					value = value.trim();

				fieldAPI.fields(fieldId).warnings("").value(value);
			});

		return formAPI.apply();
	}
}
